import Http from '@/api/http/';

export default class AiSkillInfo extends Http {
  constructor() {
    super();
  }

  /**
   * 获取能力列表
   * @param {integer} params.sourceType - 所属平台：1、嗨探，2、巡店，3、数据平台
   * @param {integer} params.userType - 用户类型：1、P端，2、B端，3、C端
   * @param {integer} params.skillType - 能力类型：1、AI能力，2、API能力
   * @param {integer} params.billingMode - 计费模式：1、租户计费，2、租户免费使用，3、平台成本
   * @param {string} params.skillName - 能力名称
   */
  aiSkillInfo_getList() {
    return super.post('aiSkillInfo/getList', ...arguments);
  }

  /**
   * 获取AI消耗统计表头
   * @param {string} params.id - 能力id
   */
  aiSkillInfo_getAiConsumeRecordHead() {
    return super.post('aiSkillInfo/getAiConsumeRecordHead', ...arguments);
  }

  /**
   * 获取使用方消耗记录列表
   * @param {string} params.id - 能力id
   * @param {string} params.companyName - 使用方名称
   * @param {integer} params.page - 页码
   * @param {integer} params.rows - 每页条数
   */
  aiSkillInfo_getAiConsumeRecordListByCompany() {
    return super.post('aiSkillInfo/getAiConsumeRecordListByCompany', ...arguments);
  }

  /**
   * 获取能力详情
   * @param {string} params.id - 能力id
   */
  aiSkillInfo_detail() {
    return super.post('aiSkillInfo/detail', ...arguments);
  }

  /**
   * 更新能力信息
   * @param {string} params.id - 能力id
   * @param {string} params.skillName - 能力名称
   * @param {integer} params.skillType - 能力类型：1、AI能力，2、API能力
   * @param {integer} params.sourceType - 所属平台：1、嗨探，2、巡店，3、数据平台
   * @param {integer} params.userType - 用户类型：1、P端，2、B端，3、C端
   * @param {integer} params.billingMode - 计费模式：1、租户计费，2、租户免费使用，3、平台成本
   * @param {string} params.modelId - 模型id
   */
  aiSkillInfo_update() {
    return super.post('aiSkillInfo/update', ...arguments);
  }

  /**
   * 获取配置详情
   * @param {string} params.id - 能力id
   */
  aiSkillInfo_getConfig() {
    return super.post('aiSkillInfo/getConfig', ...arguments);
  }

  /**
   * 更新配置
   * @param {string} params.id - 能力id
   * @param {string} params.prompt - 提示词
   */
  aiSkillInfo_updateConfig() {
    return super.post('aiSkillInfo/updateConfig', ...arguments);
  }
}
